import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
  ogType?: "website" | "product";
  jsonLd?: object | object[];
}

const SITE_NAME = "Pronto Letters by Gemini";
const DEFAULT_OG_IMAGE = "https://pronto-letters.com/og-image.jpg";
const BASE_URL = "https://pronto-letters.com";
const DEFAULT_DESCRIPTION =
  "Gemini Pronto™ changeable letter sets — injection-molded, UV-resistant, and easy to install on any sign. Shop Modern, ADM, and Condensed styles in Black, Red, and White.";

export default function SEO({
  title,
  description = DEFAULT_DESCRIPTION,
  canonical,
  ogImage = DEFAULT_OG_IMAGE,
  ogType = "website",
  jsonLd,
}: SEOProps) {
  const fullTitle = title
    ? `${title} | ${SITE_NAME}`
    : `${SITE_NAME} — Durable Changeable Letters for Signs`;
  const canonicalUrl = canonical ? `${BASE_URL}${canonical}` : BASE_URL;
  const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={SITE_NAME} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json" data-seo="true">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}